var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.45421 1.50006H17.2262L9.99094 6.9265L2.45421 1.50006ZM1.5 12.2858V2.66138L9.56177 8.46585L10.0091 8.7879L10.45 8.4572L18.5 2.4197V12.2858C18.5 12.5619 18.2761 12.7858 18 12.7858H2C1.72386 12.7858 1.5 12.5619 1.5 12.2858ZM2 6.10352e-05C0.895431 6.10352e-05 0 0.895493 0 2.00006V12.2858C0 13.3903 0.895431 14.2858 2 14.2858H18C19.1046 14.2858 20 13.3903 20 12.2858V2.00006C20 0.895492 19.1046 6.10352e-05 18 6.10352e-05H2ZM10 5.00006C10.3945 5.00006 10.7143 4.68026 10.7143 4.28578C10.7143 3.89129 10.3945 3.57149 10 3.57149C9.60551 3.57149 9.28571 3.89129 9.28571 4.28578C9.28571 4.68026 9.60551 5.00006 10 5.00006Z",
    fill: "#131A46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.781bab3a.svg";
export { ForwardRef as ReactComponent };